import StepThree from "@/components/dashboard/moneyExchange/StepThree";

export default function MoneyExchangeStepThree() {
  return <StepThree />;
}
